import React from "react";
import { IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import FormProvider, { RHFTextField } from "../components/hook-form";
import { useForm } from "react-hook-form";
import AppButton from "../components/app-components/AppButton";
import Iconify from "../components/iconify";
import { useBoolean } from "../hooks/use-boolean";
import useApiServices from "../api/useApiServices";
import "../styles/delete-acount.css";

interface DeleteAccountProps {}

const DeleteAccount: React.FC<DeleteAccountProps> = () => {
  const password = useBoolean();
  const methods = useForm({});
  const { usePostApi } = useApiServices();
  const { handleSubmit } = methods;

  const { mutate: deleteAccount, isLoading: isLoadingDeleteAccount } =
    usePostApi({ url: "/auth/delete_account_parent" });

  const onSubmit = handleSubmit((data: any) => {
    deleteAccount({
      ...data,
    });
  });

  return (
    <>
      <div className="page-header"></div>
      <div className="delete-acount-body">
        <div className="delete-acount-contact">
          <Stack
            justifyContent="center"
            alignItems="center"
            p={{ xs: 2, md: 0, lg: 0 }}
            className="stack-delete-account"
          >
            <Stack spacing={2} sx={{ mb: 5 }}>
              <Typography
                variant="h3"
                fontWeight={500}
                color="#14142A"
                align="center"
              >
                Delete Darayish Account
              </Typography>
              <Typography variant="h5" color="#4E4B66" align="center">
                Please enter your email and password
              </Typography>
            </Stack>

            <Stack spacing={2}>
              <FormProvider methods={methods} onSubmit={onSubmit}>
                <Stack spacing={2.5} className="delete-acount-input">
                  <RHFTextField name="email" label="Email address" />
                  <RHFTextField
                    name="password"
                    label="Password"
                    type={password.value ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={password.onToggle} edge="end">
                            <Iconify
                              icon={
                                password.value
                                  ? "solar:eye-bold"
                                  : "solar:eye-closed-bold"
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <AppButton
                    label="Delete Account"
                    isLoading={isLoadingDeleteAccount}
                  />
                </Stack>
              </FormProvider>
            </Stack>
          </Stack>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
